import React from 'react';
import { Button, Modal, Select, TextArea, Form, Message, RadioLabel } from '@weezevent/nacre';
import { useSegment } from '../../../../components/tracking/trackingProvider';
import { useTranslation } from 'react-i18next';
import { useForm, requiredField } from '../../../../utils/validators';
import Style from './feedbackModal.module.css';

function FeedBacksModal({ open = false, onClose }) {
    const { t } = useTranslation();
    const { track } = useSegment();
    const [form, setForm, , formErrors] = useForm(
        {
            reasonText: '',
            selectedReason: null,
            is_definitive: false
        },
        {
            reasonText: requiredField,
            selectedReason: requiredField
        }
    );

    const selectOptions = [
        { text: t('ticket.switch-nbo.modale.reason_one'), default_text: 'I encountered problems that made me unable to use the new interface', value: 1 },
        { text: t('ticket.switch-nbo.modale.reason_two'), default_text: "I don't feel at ease with the new interface", value: 2 },
        { text: t('ticket.switch-nbo.modale.reason_three'), default_text: 'I no longer wish to participate to the beta', value: 3 },
        { text: t('ticket.switch-nbo.modale.reason_default'), default_text: 'Others', value: 4 }
    ];
    const handleSubmit = React.useCallback(() => {
        let reason = '';

        if (form.selectedReason) {
            reason = selectOptions.find(o => o.value === form.selectedReason)['default_text'];
        }
        track(
            'ACTION > SWITCH BO',
            {
                'Page Title': 'Confirmation Switch BO',
                Reason: reason,
                'Reason Detailed': form.reasonText,
                'Ending beta': form.is_definitive
            },
            {
                'Switch BO last date': new Date(),
                'Beta User': false
            }
        );
        window.location.replace(`${window.weezConfig.temporary.menhirUrl}/bo/switch_nbo/0?is_definitive=${form.is_definitive}`);
        onClose();
    }, [form, onClose]);

    const handleCancel = React.useCallback(() => {
        let reason = '';

        if (form.selectedReason) {
            reason = selectOptions.find(o => o.value === form.selectedReason)['default_text'];
        }

        track('ACTION > STAY ON THE BETA', {
            'Page Title': 'Confirmation Switch BO',
            Reason: reason,
            'Reason Detailed': form.reasonText
        });
        onClose();
    }, [form, onClose]);

    const isDisabled = React.useMemo(() => {
        if (form.is_definitive) {
            return Object.values(form).some(value => !value);
        }
    }, [form]);

    return (
        <Modal
            allowExternalClosing={false}
            open={open}
            size="large"
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.switch-nbo.modale.submit')} onClick={handleSubmit} disabled={Object.keys(formErrors).length > 0 || isDisabled} />}
            cancelButton={<Button onClick={handleCancel} label={t('ticket.common.action.cancel')} />}
            title={t('ticket.switch-nbo.modale.title')}
            subtitle={t('ticket.switch-nbo.modale.subtitle')}
        >
            <Form>
                <Message type="default" title={t('ticket.switch-nbo.modale.message-title')} className={Style['message']}>
                    <p>{t('ticket.switch-nbo.modale.message-content')}</p>
                </Message>
                <Form.Field className={Style['radio-field-block']}>
                    <Form.Label>{t('ticket.switch-nbo.modale.radio-label-title')}</Form.Label>
                    <div className={Style['radio-label-container']}>
                        <RadioLabel
                            bordered
                            inline
                            label={t('ticket.switch-nbo.modale.radio-label-1')}
                            className={Style['radio-label']}
                            checked={!form.is_definitive}
                            value="not_definitive"
                            onClick={() => setForm('is_definitive', false)}
                        />
                        <RadioLabel
                            bordered
                            inline
                            label={t('ticket.switch-nbo.modale.radio-label-2')}
                            className={Style['radio-label']}
                            checked={form.is_definitive}
                            value="definitive"
                            onClick={() => setForm('is_definitive', true)}
                        />
                    </div>
                </Form.Field>
                <Form.Field error={formErrors['selectedReason'] ? true : false}>
                    <Form.Label label={t('ticket.switch-nbo.modale.select-label')} optionalText={!form.is_definitive ? t('ticket.common.labelOptional') : ''} />
                    <Select
                        placeholder={t('ticket.switch-nbo.modale.select-placeholder')}
                        options={selectOptions}
                        onChange={value => setForm('selectedReason', value)}
                        useNew
                        value={form.selectedReason}
                    />
                </Form.Field>
                {formErrors['selectedReason'] && <Form.FieldErrors errors={[formErrors['reasonText'] || null]} />}
                <Form.Field error={formErrors['selectedReason'] ? true : false}>
                    <Form.Label label={t('ticket.switch-nbo.modale.text-area-label')} optionalText={!form.is_definitive ? t('ticket.common.labelOptional') : ''} />
                    <TextArea
                        placeholder={t('ticket.switch-nbo.modale.text-area-placeholder')}
                        value={form.reasonText}
                        maxlength={500}
                        onChange={({ target: { value } }) => setForm('reasonText', value)}
                    />
                </Form.Field>
                {formErrors['reasonText'] && <Form.FieldErrors errors={[t(formErrors['reasonText']) || null]} />}
            </Form>
        </Modal>
    );
}

export default FeedBacksModal;
